import { cn, dynamicStyling } from 'styles';

import { useTable } from '../Table';
import { TableRow } from '../Row';
import { TableActions } from './Actions';

import { tableStyleConfig } from '../styles';

export function TableHeader() {
  const { columns, headerClassName: globalHeadClassName, cellClassName, spacing } = useTable();

  return (
    <thead>
      <TableRow>
        {columns.map((column, columnIndex) => (
          <th
            colSpan={column.columnSpan}
            key={
              typeof column.label === 'string'
                ? column.label
                : `header-config-${column.id || column.property || columnIndex}`
            }
            {...dynamicStyling({
              width: column.width,

              className: cn(
                'whitespace-nowrap text-start align-middle font-medium text-foreground-title',
                tableStyleConfig.spacing[spacing],
                cellClassName,
                globalHeadClassName,
                column.className,
                column.headerClassName,
              ),
            })}
          >
            {column.label ?? ' '}

            <TableActions column={column} index={columnIndex} />
          </th>
        ))}
      </TableRow>
    </thead>
  );
}
